<template>
    <div class="enquiry">
       <enquiry-container></enquiry-container>
    </div>
</template>
<script>
import EnquiryContainer from '@/components/enquiry/Container.vue'
export default {
  name: 'enquiry',
  components: {
    EnquiryContainer
  }
}
</script>
<style lang="stylus">
.enquiry
  height 100%
</style>
